import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostCreateKeys = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CREATE_KEYS
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostCreateKeys as SetPostCreateKeys
}